export default __webpack_public_path__ + "static/media/backgroundLogo.7ddc9db9.png";